module.exports = __webpack_public_path__ + "static/img/qq2.7ae9bb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qq2.png
// module id = pDhR
// module chunks = 0